import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface BankInfo {
  bankName?: string;
  accountNo?: string;
}

export interface PersonalInfo {
  maritalStatus?: string;
  nationality?: string;
  address?: string;
  phoneNumber?: string;
  dateOfBirth?: string;
  passportNo?: string;
  emergencyContact?: string;
  religion?: string;
}

export interface Member {
  _id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  password?: string;
  role?: string;
  position?: string;
  org?: string;
  department?: string;
  completedWelcome?: boolean;
  isDemo?: boolean;
  expectedDailyWorkingHours?: number;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
  bankInfo?: BankInfo;
  personalInfo?: PersonalInfo;
  employmentHistory?: any[];
  employmentType?: string;
  isDeleted?: boolean;
  startDate?: string;
  status?: string;
  isverified?: string | boolean;
}

export interface Organization {
  _id: string;
  name?: string;
  members?: Member[];
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

export type OrganizationsResponse = {
  success: boolean;
  message?: string;
  data: Organization[];
};

const fetchOrganizations = async (): Promise<OrganizationsResponse> =>
  (await customAxios.get<OrganizationsResponse>("/organizations")).data;

export const useGetOrganizations = () =>
  useQuery<OrganizationsResponse, AxiosError>(
    ["organizations"],
    fetchOrganizations,
    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Organizations",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load organizations",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
